module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'sm',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-y-auto"
  }, [_c('img', {
    staticClass: "center items-center h-24 w-24",
    attrs: {
      "src": "/static/admin_icons/unlock.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-modal px-3 py-5"
  }, [_c('p', {
    staticClass: "ph4"
  }, [_vm._v("\n        You must have a school or district-wide license to set up LMS and SIS\n        integrations.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "ph4"
  }, [_vm._v("\n        Contact our team in the chat bubble below to request an upgrade!\n      ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "flex my-8 center items-center"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      BACK\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bceca9f6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/integrations/integrationsBlockModal.vue
// module id = 2174
// module chunks = 61